export const UserRolesList = [
	{ value: 0, type: 'Unassigned', label: 'Tanımlanmamış' },
	{ value: 1, type: 'AksaAdmin', label: 'AKSA Admin' },
	{ value: 2, type: 'BgaMaster', label: 'BGA Master' },
	{ value: 3, type: 'YkYonetim', label: 'YK Yönetim' },
	{ value: 4, type: 'OnaysizIcerik', label: 'Onaysız İçerik' },
	{ value: 5, type: 'OnayliIcerik', label: 'Onaylı İçerik' },
	{ value: 6, type: 'Subscriber', label: 'Abone' },
	{ value: 7, type: 'Contributor', label: 'Katılımcı' },
	{ value: 8, type: 'Author', label: 'Yazar' },
	{ value: 9, type: 'Editor', label: 'Editör' },
	{ value: 10, type: 'Administrator', label: 'Yönetici' },
];
export const UserRoles = {
	0: 'Unassigned',
	1: "AksaAdmin",
	2: "BgaMaster",
	3: "YkYonetim",
	4: "OnaysizIcerik",
	5: "OnayliIcerik",
	6: "Subscriber",
	7: "Contributor",
	8: "Author",
	9: "Editor",
	10: "Administrator",
};
